module.exports = __webpack_public_path__ + "static/media/rocketppe_3ply.c7d2cb01.jpg";